<template>
    <div class="slide">

        <go-back />

        <div class="slide-container">

            <div class="question bigger">
                Let's focus on your goals first.
                <br>
                Are you <span>still working</span> or <span>retired</span>?
            </div>

            <div class="answer answer-col">
                <span class="alternative" @click="setPersonOneIsWorking(true)">Working</span>
                <span class="alternative" @click="setPersonOneIsWorking(false)">Retired</span>
            </div>

        </div>

    </div>
</template>

<script>
import GoBack from "./GoBack";

export default {
    name: 'PersonOneWorkingRetired',
    components: {
        GoBack
    },
    mounted() {
        this.$store.dispatch('individuals/loadIndividuals').then(() => this.individualsLoaded = true);
    },
    data() {
        return {
            individualsLoaded: false,
        }
    },
    methods: {
        setPersonOneIsWorking(isWorking) {
            // Wait until the individuals are loaded before going to the next step
            if (! this.individualsLoaded) {
                window.setTimeout(this.setPersonOneIsWorking, 100);
            } else {
                this.$store.commit('individuals/setPersonOneIsWorking', isWorking);

                this.$router.push({ name: 'MarriedSingle' });
            }
        },
    }
}
</script>
